import { action, type ActionCreator } from "satcheljs";
import type TabViewState from "../store/schema/TabViewState";

export interface ActivateTabActionMessage {
    viewState: TabViewState;
    isUserAction: boolean | undefined;
}

const activateTabAction: ActionCreator<ActivateTabActionMessage> = action("activateTab", (viewState: TabViewState, isUserAction?: boolean): ActivateTabActionMessage => ({
    viewState,
    isUserAction,
}));

export default activateTabAction;
